import { useDispatch, useSelector } from 'react-redux';
import { searchCollection as _searchCollection, clearCollection } from 'redux/actions/collection';

const useCollectionSearch = () => {
  const dispatch = useDispatch();

  const collection = useSelector(state => state.collection?.list);
  const isSearching = useSelector(state => state.collection?.isRequesting);

  const clearCollectionResults = () => {
    dispatch(clearCollection());
  };

  const searchCollection = (name, searchParams) => {
    dispatch(_searchCollection({ name, searchParams }));
  };

  return {
    collection,
    isSearching,
    clearCollectionResults,
    searchCollection
  };
};

export default useCollectionSearch;
